// @flow
import React, { useEffect, useState, useRef } from 'react';
import type { Node } from 'react';
import ReactDOM from 'react-dom';
import Debug from 'debug';
import OlOverlay from 'ol/Overlay';
import { useMap } from '../index';

const debug = Debug('amms:modules:openlayers:overlay');

type Props = $ReadOnly<{
    position: [number, number],
    positioning: 'bottom-left' | 'bottom-center' | 'bottom-right' | 'center-left' | 'center-center' | 'center-right' | 'top-left' | 'top-center' | 'top-right',
    children: Node
}>;

function Overlay({ position, positioning, children }: Props) {
    const map = useMap();
    const ref = useRef();
    const [overlay] = useState(new OlOverlay({
        insertFirst: true
    }));

    const getRef = (element) => {
        if(element && (!ref.current || element !== ref.current) ) {
            debug('Adding overlay');
            ref.current = element;
            overlay.setElement(element);
            map.addOverlay(overlay);
        }
    };

    useEffect(() => {
        debug('Setting overlay position');
        overlay.setPosition(position);
    }, [overlay, position]);

    useEffect(() => {
        debug('Setting overlay positioning');
        overlay.setPositioning(positioning);
    }, [overlay, positioning]);

    useEffect(() => {
        return () => {
            const map = overlay.getMap();
            if(map) {
                debug('Removing overlay');
                map.removeOverlay(overlay);
            }
        };
    }, [overlay]);

    return ReactDOM.createPortal(
        (
            <div ref={getRef}>
                {children}
            </div>
        ),
        overlay.element
    );
}

export default Overlay;